import { FormValidatorBuilder } from '../../../../../validator';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { IWidgetType } from '../../../IWidgetType';
import { ISubsectionWidget } from './ISubsectionWidget';

export const createSubsectionSchema: IWidgetType<ISubsectionWidget>['createFormSchema'] =
  ({ widget, section, page, parentScope }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    // La sottosezione in sé non ha un valore, quindi inserisco tutti i suoi campi
    // all'interno del validatore come se fossero root
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  };
